import GiftSVG from "@design-system/ui-icons/vanilla/Gift"
import { createIcon } from "../createIcon"

export const GiftIcon = createIcon(GiftSVG)
